<template>
  <!-- 天氣資訊 -->

  <div class="row g-2 mb-2">
    <div class="col-12">
      <div class="card card-clean h-100">
        <div class="card-header bg-white border-0 fw-bold text-indigo h5">
          天氣資訊
        </div>
        <div class="card-body p-2">
          <div class="container">
            <div class="row">
              <div class="col-12 mb-1 p-2">
                <div class="container text-center">
                  <div class="row row-cols-lg-8 align-items-center block-3 ">
                    <div class="col mb-4">
                      <p class="font-weight-bold h6  ">天氣預警</p>
                      <div class="block-4">
                      <svg
                        class="bd-placeholder-img rounded-circle border border-3 border-light mt-3"
                        width="40"
                        height="40"
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        focusable="false"
                      >
                        <title>天氣預警</title>
                       
                        <rect
                          width="100%"
                          height="100%"
                          
                          :class="
                            !totalAlert
                              ? 'total-alert-normal'
                              : 'total-alert-danger'
                          "
                        ></rect>
                      </svg>
                      <h6
                        class=" text-green font-weight-bold m-0"
                        v-if="!totalAlert"
                      >
                        正常
                      </h6>
                      <h6
                        class="mt-2 text-red font-weight-bold m-0"
                        v-if="totalAlert"
                      >
                        管制
                      </h6>
                    </div>
                    </div>

                    <div
                      class="col mb-4"
                      v-for="(weather, i) in weatherPlate"
                      :key="i"
                    >
                      <p class="font-weight-bold h6">
                        {{ weather.name }}
                      </p>
                      <div
                        class="alert-circle"
                        :class="checkWeatherAlert(weather)"
                      >
                        <b
                          class="display-6"
                          :class="checkWeatherAlert(weather)"
                        >
                          {{
                            !scienicWeatherData ||
                            scienicWeatherData[weather.key] === -99 ||
                            scienicWeatherData[weather.key] === "" ||
                            scienicWeatherData[weather.key] === 0
                              ? "-"
                              : scienicWeatherData[weather.key]
                          }}</b
                        >
                        <p>{{ weather.unit }}</p>
                      </div>
                    </div>
                    <!-- 颱風/地震 特報 -->
                    <div
                      class="col-8 col-xl-3 special-news rounded-3 p-2"
                      v-if="earthquakeAlert === true || typhoonAlert === true"
                    >
                      <div class="container text-center">
                        <b class=""> 特報</b>
                        <div class="row">
                          <div
                            class="col mb-1"
                            v-for="(weather, i) in weatherPlateSpecial"
                            :key="i"
                            :class="checkWeatherAlert(weather)"
                          >
                            <div>
                              <div class="my-2 font-weight-bold">
                                {{ weather.name }}
                              </div>
                              <img
                                :src="
                                  require(`@/assets/img/${weather.key}.svg`)
                                "
                                class="alert-img"
                              />
                            </div>
                            <div class="my-2 font-weight-bold">
                              {{
                                !scienicWeatherData ||
                                scienicWeatherData[weather.key] === -99 ||
                                scienicWeatherData[weather.key] === ""
                                  ? "-"
                                  : scienicWeatherData[weather.key] +
                                    weather.unit
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 颱風/地震 特報 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";

export default {
  components: {},
  props: {
    selectedScenicAreaId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      scienicDisastersData: [],
      scienicWeatherData: [],
      typhoonAlert: true,
      earthquakeAlert: true,

      totalAlert: false,

      weatherCSS: {
        normal: " text-normal",
        danger: " text-red font-weight-bold",
        normalCircle: " alert-circle",
        dangerCircle: " alert-circle-danger",
        hide: "alert-hide",
        textSmall:"text-small"
      },
      weatherPlate: [
        {
          name: "風力",
          unit: "級",
          key: CONST.HOME_PAGE_WEATHER_ITEM.WIND_POWER,
          id: 6,
        },
        {
          name: "陣風",
          unit: "級",
          key: CONST.HOME_PAGE_WEATHER_ITEM.GUST,
          id: 7,
        },
        {
          name: "浪高",
          unit: "公尺",
          key: CONST.HOME_PAGE_WEATHER_ITEM.WAVE,
          id: 8,
        },
        {
          name: "長浪",
          unit: "",
          key: CONST.HOME_PAGE_WEATHER_ITEM.SWELL,
          id: 9,
        },
      ],

      weatherPlateSpecial: [
        {
          name: "地震",
          unit: "級",
          key: CONST.HOME_PAGE_WEATHER_ITEM.EARTHQUAKE,
          id: 10,
        },
        {
          name: "颱風",
          unit: "",
          key: CONST.HOME_PAGE_WEATHER_ITEM.TYPHOON,
          id: 11,
        },
      ],
    };
  },
  created() {

  },
  methods: {
    async getScienicDisasters() {
      await this.$store.dispatch("disasterSetting/getDisasterSettingByArea", {
        id: this.selectedScenicAreaId,
      });
      this.scienicDisastersData = this.$store.getters[
        "disasterSetting/getDisasterSettingByArea"
      ](this.selectedScenicAreaId);


    },

    //根據選擇景區更改天氣資訊
    async getScienicWeatherData() {
      const a = await this.cwbWeatherData.filter(
        (sc) => sc.scenicAreaId === this.selectedScenicAreaId
      );

      this.scienicWeatherData = a[0];
    },

    //根據景區警報閥值更改顯示樣式
    checkWeatherAlert(weather) {

      if(Utils.isEmptyObject(this.scienicDisastersData)){
        return
      }
      // //尋找該天氣資訊對應閥值
      const values = Object.values(this.scienicDisastersData.disaster);
      const target = values.find((item) => item.conditionType === weather.key);
      let css = "";
      // console.log("this.scienicDisastersData", this.scienicDisastersData);
      // console.log("value", values);
      // console.log("target", target);


      //先判斷景區是否有設定該天氣閥值，則return
      if (Utils.isEmptyString(target)) {
        // console.log("未設定閥值");
        css = this.weatherCSS.normal;

        return css;
      }

      switch (target.conditionType) {
        
        // case 9: // 長浪
        case CONST.HOME_PAGE_WEATHER_ITEM.SWELL: // 長浪
        // console.log("9",this.scienicWeatherData[weather.key])
        // console.log("9",this.scienicWeatherData)

          if (this.scienicWeatherData[weather.key] === target.magnitudeValue) {
            // console.log("長浪過閥值");
            css = this.weatherCSS.danger + " " + this.weatherCSS.dangerCircle + " " + this.weatherCSS.textSmall;
            this.totalAlert = true;
          } else {
            // console.log("長浪沒過閥值");
            css = this.weatherCSS.normal +" "+ this.weatherCSS.textSmall;
          }
          
          break;

        // case 6:
        // case 7:
        // case 8:
        case CONST.HOME_PAGE_WEATHER_ITEM.WAVE: // 浪高
        case CONST.HOME_PAGE_WEATHER_ITEM.WIND_POWER: // 風力
        case CONST.HOME_PAGE_WEATHER_ITEM.GUST: // 陣風
          //若景區有設定閥值，但測得天氣值為空，則設定為0，才能與閥值比較
          if (this.scienicWeatherData[weather.key] === "") {
            this.scienicWeatherData[weather.key] = 0;
          }
          //測得天氣值與閥值比較
          if (this.scienicWeatherData[weather.key] < target.magnitudeValue) {
            css = this.weatherCSS.normal;
          } else {
            css = this.weatherCSS.danger + "" + this.weatherCSS.dangerCircle;
            
          }
          break;

        // case 10: // 地震
        case CONST.HOME_PAGE_WEATHER_ITEM.EARTHQUAKE: // 地震

          if (this.scienicWeatherData[weather.key] >= target.magnitudeValue) {
            this.earthquakeAlert = true;
            this.totalAlert = true;
          } else {
            this.earthquakeAlert = false;
            css = this.weatherCSS.hide;
          }
          break;
        // case 11: // 颱風
        case CONST.HOME_PAGE_WEATHER_ITEM.TYPHOON:  // 颱風
        
          // 1.氣象局沒有陸上颱風警報: 解除颱風警報
          // 2.有颱風警報但景區不在警戒範圍: 颱風警報-未涵蓋本區
          // 3.有颱風警報且景區在警戒範圍: 颱風警報-涵蓋本區 (景區管制)

          if (this.scienicWeatherData[weather.key] !== target.magnitudeValue) {
            this.typhoonAlert = false;
            css = this.weatherCSS.hide;
          } else {
            this.typhoonAlert = true;
            this.totalAlert = true;
          }
          break;
      }

      return css;
    },
  },
  computed: {
    ...mapGetters("weatherMonitor", { cwbWeatherData: "getAllWeather" }),

  },

  watch: {
    selectedScenicAreaId: {
      async handler(newVal) {
    
        await this.getScienicDisasters();
        this.getScienicWeatherData();
      },
      immediate: true,
    },

    cwbWeatherData: {
      async handler(newVal) {
        await this.getScienicWeatherData();

        this.totalAlert = false;
      },
      // immediate: true,
    },
  },
  async mounted() {

  },
};
</script>

<style lang="scss" scoped>

.block-4{
  width:80px;
  height:80px;
  margin-left:auto;
  margin-right:auto;
}
.text-normal {
  color: var(--bs-teal);
}

.total-alert-normal {
  fill: var(--bs-green);
}
.total-alert-danger {
  fill: var(--bs-red);
}

.alert-circle {
  width: 80px;
  height: 80px;
  text-align: center;
  padding: 18px 0px;
  background-color: var(--bs-white);
  border: 2px solid var(--bs-teal);
  border-radius: 100%;
  display: block;
  vertical-align: top;
  font-size: 12px;
  margin: 0px auto;
}
.alert-circle-danger {
  border: 2px solid var(--bs-red);
}
.alert-circle b {
  font-size: 1.6rem;
  font-weight: bold;
  // color: var(--bs-teal);
}

.text-small{
  font-size: 14px !important; 
  line-height: 40px;
}


.special-news {
  background-color: #f8f9fa;
}

.display-6 {
  border: none !important;
}

.alert-hide {
  display: none;
}

.alert-img {
  width: 3.5rem;
}

.block-3 div:nth-child(5)>div>b{
  font-size: 14px !important; 
  line-height: 40px;
}
</style>
